import { Routes, Route, Navigate } from "react-router-dom";

import Admin from "./Admin";

const index = () => {
	return (
		<Routes>
			<Route index element={<Admin />} />
			<Route path='/settings' element={<Navigate to="/view/admin?tab=settings" replace />} />
			<Route path='/trigger' element={<Navigate to="/view/admin?tab=trigger" replace />} />
			<Route path='/language' element={<Navigate to="/view/admin?tab=language" replace />} />
			<Route path='/support' element={<Navigate to="/view/admin?tab=support" replace />} />
			<Route path='/navigation' element={<Navigate to="/view/admin?tab=navigation" replace />} />
		</Routes>
	);
};

export default index;
